import React from 'react';
import styled from '@emotion/styled';
import { ReactComponent as Icon } from '../../../assets/images/icons/cards.svg';

const Container = styled.span`
  svg {
    #cards-card-1 {
      fill: ${(props) => props.theme.colors.iconsPrimaryColor};
    }
    #cards-card-2 {
      fill: ${(props) => props.theme.colors.iconsSecondaryColor};
    }
  }
`;

const CardsIcon = () => (
  <Container>
    <Icon />
  </Container>
);

export default CardsIcon;
